// extracted by mini-css-extract-plugin
export default {"adUnitPlaceholder":"adUnitPlaceholder__lDi9h","placeholder":"placeholder__rS8cI"};